import React from "react";
import DataGrid from "../../../../dataGrid";
import GridConfig from "./gridConfig";
import { withStyles } from "@material-ui/core";
import styles from "../../styles";
import { postData } from "../../../../../api/componentAPIs";
import { compose } from "recompose";
import { withSnackbar } from "notistack";
import Events from "../../../../../utilities/EventEmitter";
import StatusBar from "../../../../dataGrid/StatusBar";
import MESSAGES from "../../../../../appMessages";
import { isEqual } from "lodash/lang";
import { trackEvent } from "../../../../common/AppInsightsEventTracking";
import AnchorPointGridHeader from "./gridHeader";
import DeleteAnchorPoint from "./deleteAnchorPoint";
import ShowingInProgressPopup from "./showingInProgressPopup";

class AnchorPointGrid extends React.Component {
  constructor(props) {
    super(props);
    this.gridConfig = new GridConfig();
    this.gridApi = null;
    this.state = {
      filterData: "",
      selectedAnchorPoints: null,
      isDeleteAnchorPointPopupOpen: false,
      isAnchorPointSelectOnGrid: false,
      enableAllAnchorPoints: this.isAllAnchorPointsEnabled(),
      isEnableAnchorPointsInProgress: false,
    };
    this.gridContext = {
      disabled: false,
      tooltipTitle: "",
    };
  }

  componentDidUpdate(prevProps) {
    if (
      !isEqual(this.props.selectedAnchorPoints, prevProps.selectedAnchorPoints)
    ) {
      this.updateSelection();
    }
    if (prevProps.data !== this.props.data) {
      this.setState({
        enableAllAnchorPoints: this.isAllAnchorPointsEnabled()
      })
    }
  }

  updateSelection = () => {
    if (this.gridApi) {
      this.gridApi.forEachNode((node) => {
        if (
          this.props.selectedAnchorPoints &&
          this.props.selectedAnchorPoints.includes(node.data.anchorPointName)
        ) {
          this.gridApi.ensureIndexVisible(node.rowIndex);
          node.setSelected(true, false, true);
        } else {
          node.setSelected(false, false, true);
        }
      });
      this.gridApi.dispatchEvent({
        type: "selectionChanged",
        api: this.gridApi,
      });
    }
  };

  onGridReady = ({ api }) => {
    this.gridApi = api;
  };

  onDataUpdated = (params) => {
    if (params.colDef.field === "routeAssigned") {
      if (params.newValue !== null) {
        const routeString = params.newValue
          .map((route) => route.label)
          .join(", ");
        if (params.oldValue !== routeString) {
          const routeIdString = params.newValue
            .map((route) => route.value)
            .join(", ");
          this.anchorPointBackup = {
            routeAssigned: params.oldValue,
            routeId: params.data.routeId,
          };
          this.updateUI(params, {
            routeAssigned: routeString,
            routeId: routeIdString,
          });
          this.updateAnchorPoint(params);
        } else {
          params.data["routeAssigned"] = params.oldValue;
          this.gridApi.refreshCells();
        }
      } else if (params.oldValue !== null) {
        this.anchorPointBackup = {
          routeAssigned: params.oldValue,
          routeId: params.data.routeId,
        };
        this.updateUI(params, { routeAssigned: null, routeId: null });
        this.updateAnchorPoint(params);
      }
    } else if (
      params.colDef.field === "isSelected" &&
      params.oldValue !== params.newValue
    ) {
      this.updateAnchorPoint(params);
    }
  };

  updateUI = (params, updatedData) => {
    if (updatedData) {
      Object.keys(updatedData).forEach((key) => {
        params.data[key] = updatedData[key];
      });
      this.updateGridContext({ disableGridContext: false, tooltipTitle: "" });
    }
  };

  deleteAnchorPoint = () => {
    const data = {
      scenarioId: this.props.scenarioId,
      anchorPointNames: this.state.selectedAnchorPoints.map((anchorPoint) => {
        return anchorPoint.anchorPointName;
      }),
    };
    postData("DeleteAnchorPoint", data).then(
      (response) => {
        if (response && response.status >= 200 && response.status < 400) {
          this.props.updateAnchorPointDataInStore();
        } else {
          const errorMessage =
            data.anchorPointNames.length > 1 &&
            `Error while deleting anchor point ${data.anchorPointNames[0]}`;
          this.props.enqueueSnackbar(
            `${
              data.anchorPointNames.length > 1
                ? "Error while deleting anchor points"
                : errorMessage
            }`,
            { variant: "error" }
          );
        }
      },
      (error) => {
        this.props.enqueueSnackbar(
          `${
            data.anchorPointNames.length > 1
              ? "Error while deleting anchor points"
              : errorMessage
          }`,
          { variant: "error" }
        );
      }
    );
  };
  updateAnchorPoint = (params) => {
    let requestParams = {
      scenarioId: this.props.scenarioId,
      routeNames: params.data.routeAssigned
        ? params.data.routeAssigned.split(", ")
        : [],
      anchorPointName: params.data.anchorPointName,
      isSelected: params.data.isSelected,
    };
    /*Added enableAllAnchorPoints to make req for enable/disable all anchor points at once*/
    if (params?.enableAllAnchorPoints !== undefined) { 
      requestParams["enableAllAnchorPoints"] = params.enableAllAnchorPoints
    }

    this.updateGridContext({
      disableGridContext: true,
      tooltipTitle: "Please wait for the last update to finish",
    });

    this.setState({
      isEnableAnchorPointsInProgress:true,
    });

    postData("UpdateAnchorPoint", requestParams).then(
      (response) => {
        if (response && Math.trunc(response.status / 100) === 2) {
          if (params?.enableAllAnchorPoints !== undefined) {
            this.props.enqueueSnackbar(
              `All anchor points ${params?.enableAllAnchorPoints?"enabled":"disabled"}`,
              { variant: "success" }
            )
          } else if (params.colDef.field === "routeAssigned") {
            this.props.enqueueSnackbar(
              `Anchor point ${params.data.anchorPointName} updated`,
              { variant: "success" }
            );
            this.props.onDataUpdated();
          } else if (params.colDef.field === "isSelected") {
            if (requestParams.isSelected) {
              this.props.enqueueSnackbar(
                `Anchor point ${params.data.anchorPointName} enabled`,
                { variant: "success" }
              );
            } else {
              if (
                requestParams.routeNames &&
                requestParams.routeNames.length > 0
              ) {
                this.props.enqueueSnackbar(
                  `Anchor point ${
                    params.data.anchorPointName
                  } disabled & dropped from ${
                    requestParams.routeNames.length > 1 ? "routes" : "route"
                  }  ${params.data.routeAssigned}`,
                  { variant: "success" }
                );
              } else {
                this.props.enqueueSnackbar(
                  `Anchor point ${params.data.anchorPointName} disabled`,
                  { variant: "success" }
                );
              }
            }
            this.props.onDataUpdated();
          }
          Events.emit("RefreshIBStore", false);
           this.setState({
             isEnableAnchorPointsInProgress: false,
           });
          this.updateGridContext({
            disableGridContext: false,
            tooltipTitle: "",
          });
        } else {
          this.handleUpdateAnchorPointError(params, requestParams);
        }
      },
      (error) => {
        this.handleUpdateAnchorPointError(params, requestParams);
      }
    );

    const userProfile = this.props.userProfile;
    const eventSpecificData = {
      anchorPoint: params.data.anchorPointName,
      anchorPointEnabled: requestParams.isSelected,
      routeAssigned: params.data.routeAssigned,
    };
    trackEvent("AnchorPointUpdated", userProfile, eventSpecificData);
  };

  handleUpdateAnchorPointError = (params, requestParams) => {
    if (params?.enableAllAnchorPoints !== undefined) {
      this.props.enqueueSnackbar(
        `Error while  ${params.enableAllAnchorPoints? "enabling": "disabling"} all anchor points`,
        { variant: "error" }
      );
      this.setState(prevState => ({
        ...prevState,
        enableAllAnchorPoints: this.isAllAnchorPointsEnabled()
      }))
    }
    else if (params.colDef.field === "routeAssigned") {
      this.props.enqueueSnackbar(
        `Error while updating anchor point ${params.data.anchorPointName}`,
        { variant: "error" }
      );
      this.updateUI(params, this.anchorPointBackup);
    } else if (params.colDef.field === "isSelected") {
      this.props.enqueueSnackbar(
        `Error while ${
          requestParams.isSelected ? "enabling" : "disabling"
        } anchor point ${params.data.anchorPointName}`,
        { variant: "error" }
      );
      this.updateUI(params, { isSelected: params.oldValue });
    }
    this.props.onDataUpdated();
  };

  onSelectionChanged = () => {
    if (this.props.anchorPointSelectedOnGrid && this.gridApi) {
      const selectedAnchorPoints = this.gridApi
        .getSelectedRows()
        .map((anchor) => anchor);
      this.props.anchorPointSelectedOnGrid(selectedAnchorPoints);
      this.setState({ selectedAnchorPoints: selectedAnchorPoints });
    }
  };

  onDoubleClicked = (params) => {
    if(params.colDef.field === "routeAssigned" && !params.data.isSelected){
      this.props.enqueueSnackbar(MESSAGES.ANCHORPOINT.DISABLED_ANCHORPOINT, {variant: "info"});
  }
}
  isAllAnchorPointsEnabled = () => {
    const { totalAnchorPoint, enabledAnchorPoints } = this.getAnchorPointCount();
    return totalAnchorPoint === enabledAnchorPoints
  }

  getAnchorPointCount = () => {
    let [totalAnchorPoint, enabledAnchorPoints] = [0, 0];
    if (this.props.data) {
      totalAnchorPoint = this.props.data.length;
      enabledAnchorPoints = this.props.data.filter(
        (anchorPoint) => anchorPoint.isSelected
      ).length;
    }
    return {totalAnchorPoint, enabledAnchorPoints };
  };

  doesExternalFilterPass = (node) => {
    switch (this.state.filterData) {
      case "enabledAnchor":
        return Boolean(node.data.isSelected);
      default:
        return true;
    }
  };

  updateGridData = (updatedFilterData) => {
    this.setState(
      {
        filterData: updatedFilterData,
      },
      () => this.gridApi.onFilterChanged()
    );
  };

  constructStatusBar = () => {
    const { totalAnchorPoint, enabledAnchorPoints } = this.getAnchorPointCount();

    const statusBarData = [
      {
        label: totalAnchorPoint + " Anchor Points",
        filterCondition: "",
      },
      {
        label: enabledAnchorPoints + " Enabled",
        filterCondition: "enabledAnchor",
      },
    ];
    return statusBarData;
  };
  deleteAnchorPointPopupClose = () => {
    this.setState({ isDeleteAnchorPointPopupOpen: false });
  };
  deleteAnchorPointPopupOpen = () => {
    this.setState({ isDeleteAnchorPointPopupOpen: true });
  };
  deleteAnchorPointConfirm = () => {
    this.deleteAnchorPoint();
  };
  updateGridContext({ disableGridContext, tooltipTitle }) {
    this.gridContext.disabled = disableGridContext;
    this.gridContext.tooltipTitle = tooltipTitle;
    this.gridApi.refreshCells({ force: true });
  }

  onCellFocused = (params) => {
    if (this.props.isAddUpdateAnchorPointFormOpen) {
      if (!params.event.ctrlKey || this.state.selectedAnchorPoints) {
        this.setState({
          isAnchorPointSelectOnGrid: true,
        });
      }
    }
  };

  cancelAnchorPointSelection = () => {
    this.setState({
      isAnchorPointSelectOnGrid: null,
    });
  };

  onAllAnchorPointToggleClicked = (enableAllAnchorPoints) => {
    this.setState({enableAllAnchorPoints}, 
      this.updateAnchorPoint({
        data:{anchorPointName: null, isSelected: false, routeAssigned:""},
        enableAllAnchorPoints
      })
    )
  };

  render(){
    const { config } = this.gridConfig;
    const { classes, error, data } = this.props;
    return (
      <div className={classes.anchorSubModulePart}>
        <div className={classes.anchorPointModuleContainer}>
          <AnchorPointGridHeader
            selectedAnchorPoints={this.state.selectedAnchorPoints}
            deleteAnchorPointPopupOpen={this.deleteAnchorPointPopupOpen}
            updateAnchorPointOpen={this.props.updateAnchorPointOpen}
            addAnchorPointOpen={this.props.addAnchorPointOpen}
            enableAllAnchorPoints={this.state.enableAllAnchorPoints}
            onAllAnchorPointToggleClicked={this.onAllAnchorPointToggleClicked}
            isAddUpdateAnchorPointFormOpen={
              this.props.isAddUpdateAnchorPointFormOpen
            }
            isEnableAnchorPointsInProgress={
              this.state.isEnableAnchorPointsInProgress
            }
          ></AnchorPointGridHeader>
          <div className={`${classes.dataGrid} ${classes.anchorPointContent}`}>
            {!error ? (
              <DataGrid
                defaultColDef={config.defaultColDef}
                columnDefs={config.columns}
                config={config}
                enableFilter={config.enableFilter}
                enableSorting={config.enableSorting}
                rowSelection={config.rowSelection}
                rowDeselection={config.rowDeselection}
                rowData={data}
                onGridReady={this.onGridReady}
                onCellValueChanged={this.onDataUpdated}
                onSelectionChanged={this.onSelectionChanged}
                onCellDoubleClicked={this.onDoubleClicked}
                onRowDataChanged={this.updateSelection}
                suppressRowClickSelection={
                  this.props.isAddUpdateAnchorPointFormOpen
                }
                onCellMouseDown={this.onCellFocused}
                panelLabel={(filteredData) => (
                  <StatusBar
                    data={this.constructStatusBar(filteredData)}
                    filterGridData={this.updateGridData}
                  />
                )}
                isExternalFilterPresent={() => Boolean(this.state.filterData)}
                doesExternalFilterPass={this.doesExternalFilterPass}
                context={this.gridContext}
              />
            ) : (
              <div className={classes.errorMessageContainer}>
                <div className={classes.errorMessage}> {error} </div>
              </div>
            )}
          </div>
        </div>
        {this.state.isDeleteAnchorPointPopupOpen && (
          <DeleteAnchorPoint
            selectedAnchorPoints={this.state.selectedAnchorPoints}
            onCancel={this.deleteAnchorPointPopupClose}
            onConfirm={this.deleteAnchorPointConfirm}
          ></DeleteAnchorPoint>
        )}
        {this.state.isAnchorPointSelectOnGrid && (
          <ShowingInProgressPopup
            onClose={this.cancelAnchorPointSelection}
            anchorPointsInfo={this.props.anchorPointsInfo}
          ></ShowingInProgressPopup>
        )}
      </div>
    );
  }
}
export default compose(withStyles(styles), withSnackbar)(AnchorPointGrid);
